<script setup>
import {ref} from 'vue';
import Card from "primevue/card";
import DefaultLayout from '../../layouts/default.vue';
import ContactsTable from "@/components/customer/ContactsTable.vue";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";

const search = ref('');
</script>
<template>
  <DefaultLayout>
    <Card class="w-full flex-1 flex flex-col min-h-0"
          :pt="{
            body: { class: 'flex-1 flex flex-col h-full' },
            content: { class: 'p-0 flex-1 flex flex-col min-h-0' }
          }"
    >
      <template #title>
        <div class="flex justify-between">
          <IconField class="pt-2">
            <InputIcon class="pi pi-search pt-1" />
            <InputText v-model="search" placeholder="Поиск контакта..." size="small" />
          </IconField>
        </div>
      </template>
      <template #content>
        <ContactsTable :search="search" />
      </template>
    </Card>
  </DefaultLayout>
</template>

<style scoped>
</style>